export const isSuperAdmin = (profile = {}) => !profile?.role || profile.role === "super_admin";

const SUB_ADMIN_PERMISSION_GROUPS = new Set([
    "shipping_order",
    "revenue",
    "replacement",
    "support_query",
    "payment_history",
]);

export const hasPermission = (profile, permission) => {
    if (!permission) return true;
    if (isSuperAdmin(profile)) return true;
    const group = String(permission).split(".")[0];
    if (profile?.role === "sub_admin" && !SUB_ADMIN_PERMISSION_GROUPS.has(group)) return false;
    return Boolean(
        profile?.permissions?.includes(permission) ||
        profile?.permissions?.includes(`${group}.view`)
    );
};

export const hasAnyPermission = (profile, permissions = []) => {
    if (!permissions?.length) return true;
    return permissions.some((permission) => hasPermission(profile, permission));
};

export const getItemPermissions = (item) => {
    if (item?.permissions) return item.permissions;
    if (item?.permission) return [item.permission];
    return [];
};

export const filterMenuItems = (items = [], profile = {}) =>
    items
        .map((item) => {
            const children = item.items ? filterMenuItems(item.items, profile) : undefined;
            const itemAllowed = hasAnyPermission(profile, getItemPermissions(item));
            if (item.items) {
                if (!children.length) return null;
                return { ...item, items: children };
            }
            return itemAllowed ? item : null;
        })
        .filter(Boolean);

export const getFirstAllowedPath = (items = [], profile = {}) => {
    for (const item of items) {
        if (item.items) {
            const nested = getFirstAllowedPath(item.items, profile);
            if (nested) return nested;
        } else if (item.to && hasAnyPermission(profile, getItemPermissions(item))) {
            return item.to;
        }
    }
    return "/profile";
};
